import React from 'react';
import { Alert } from 'react-bootstrap';
import { InconsistenciesContext } from '../../app';
import { Checkbox } from '../../../form';

export const Inconsistencies: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <InconsistenciesContext.Consumer>
      {(value) => {
        if (value.length > 0) {
          return (
            <>
              {value.filter((inconsistency) => inconsistency.validationRuleLevel === 'ERROR').length > 0 && (
                <Alert variant="danger">
                  <div>
                    Some information in your deposit is incorrect and the submission is not allowed. Please verify the following details in
                    your deposit and submit the Final Terms again:
                  </div>
                  <ul className="mb-0">
                    {value
                      .filter((inconsistency) => inconsistency.validationRuleLevel === 'ERROR')
                      .map((inconsistency, index) => (
                        <li key={index}>{inconsistency.message}</li>
                      ))}
                  </ul>
                </Alert>
              )}
              {value.filter((inconsistency) => inconsistency.validationRuleLevel === 'WARNING').length > 0 && (
                <Alert variant="warning">
                  <div>
                    Some information in your deposit could be incorrect but the submission is allowed. Please verify the following details
                    in your deposit and submit the Final Terms again:
                  </div>
                  <ul className="mb-0">
                    {value
                      .filter((inconsistency) => inconsistency.validationRuleLevel === 'WARNING')
                      .map((inconsistency, index) => (
                        <li key={index}>{inconsistency.message}</li>
                      ))}
                  </ul>
                  <br />
                  <Checkbox
                    label="Bypass warning"
                    help="Select in case you want to submit with the warning rules"
                    controlId={'forceWarning'}
                  />
                </Alert>
              )}
            </>
          );
        }
      }}
    </InconsistenciesContext.Consumer>
  );
};
